import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShepherdState } from './types';

const initialState: ShepherdState = {
  status: 'idle',
  completedAt: null,
  seenVersion: 0,
};

const shepherdSlice = createSlice({
  name: 'shepherd',
  initialState,
  reducers: {
    // Completion and skip are deliberately the same thing (spec section 5).
    markShepherdDone: (state, action: PayloadAction<{ version: number }>) => {
      state.status = 'done';
      state.completedAt = new Date().toISOString();
      state.seenVersion = Math.max(state.seenVersion, action.payload.version);
    },
    resetShepherd: () => initialState,
  },
});

export const { markShepherdDone, resetShepherd } = shepherdSlice.actions;
export default shepherdSlice.reducer;
